import { IPaging } from "src/models/paging";
import { IVehicle } from "src/models/vehicle";
import { END_POINT_VEHICLE } from "./apiEndPoints";
import ApiManager from "./apiManager";

export class VehicleApi {
  async postVehicle(data: IVehicle): Promise<any> {
    const res = await ApiManager.post(END_POINT_VEHICLE, data);
    if (res) {
      return res;
    }
    return undefined;
  }

  async updateVehicle(_id: string, data: IVehicle): Promise<any> {
    const res = await ApiManager.put(`${END_POINT_VEHICLE}/${_id}`, data);
    if (res) {
      return res;
    }
    return undefined;
  }

  async getVehicles(filter: string): Promise<IPaging<IVehicle>> {
    const res = await ApiManager.get(`${END_POINT_VEHICLE}${filter}`);
    if (res) {
      return res;
    }
    return undefined;
  }

  async getVehicleById(_id: string): Promise<IVehicle> {
    const res = await ApiManager.get(`${END_POINT_VEHICLE}/${_id}`);
    if (res) {
      return res;
    }
    return undefined;
  }
}

export default new VehicleApi();
